import { Component, ViewChild } from '@angular/core';

import { NceService } from '../services/nce.service';

import { CONFIGURATION } from '../../shared/configuration/configuration';

import { StorageService } from '../../shared/services/storage.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { FileService } from '../../shared/services/file.service';

@Component({
    selector: 'nce-upload-attachment',
    templateUrl: 'upload-attachment.component.html'
})
export class NceUploadAttachmentComponent{

    isExtensionNCE: string;

    @ViewChild('fileInputSketch') vFileInputSketch;
    @ViewChild('fileInputSchedule') vFileInputSchedule;
    @ViewChild('fileInputSupport') vFileInputSupport;
    @ViewChild('fileInput') vFileInput;

    // vFile = {
    //     sketchFile: {name:''},
    //     scheduleFile: {name:''},
    //     otherFile: {name:''}
    // };

    constructor(
        private _nceService: NceService,
        private _layoutService: LayoutService, 
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _popupService: PopupService,
        private _fileService: FileService,
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('nce-upload-attachment');
        this.isExtensionNCE = this._storageService.getSessionItem('extensionNCE');
        if(this._nceService.getRequestID() === '' || this._nceService.getRequestID() === undefined){
            return;
        }
        this._nceService.resetNCEData();
        this._nceService.resetUploadDocumentData();
    }

    submitAttachment(){
        let vLink = this.isExtensionNCE === '1' ? ['nce-application/preview'] : ['nce-application/declaration'];
        this._pageNavigationService.navigate(vLink);
    }

    goBack(){
        let vLink = ['nce-application/earthwork-details'];
        this._pageNavigationService.navigate(vLink);
    }

    getFileList(){
        return this._fileService.getFileLists();
    }

    isLoading(){
        return this._fileService.isLoading();
    }

    isDisableSubmit(){
        return this._nceService.isDisableSaveUpload();
    }

    fileEvent(fileInput: any, type: string){
        let file = fileInput.target.files[0];
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Error', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
        }
        else if(file !== undefined){
            if(type === 'sketch'){
                this.overwriteFile(file, type, 0);
            } else if (type === 'schedule'){
                this.overwriteFile(file, type, 1);
            } else if (type === 'support'){
                this.overwriteFile(file, type, 2);
            }
        }
        this.vFileInputSketch.nativeElement.value = "";
        this.vFileInputSchedule.nativeElement.value = "";
        this.vFileInputSupport.nativeElement.value = "";
    }

    fileEventMultiple(fileInput: any){
        let file = fileInput.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return;
        }
        if(this._fileService.getMultipleFilesList().some(x => x === file.name)){
            this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
            return;
        }
        this._fileService.getMultipleFilesList().push(file.name);
        this._fileService.getSignedRequest(file, 'nce', 'plantmap', this._nceService.getRequestID(), this._nceService.getRecordID());
        this.vFileInput.nativeElement.value = "";
    }

    fileEventNewMultiple(fileInput: any){
        let file = fileInput.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return;
        }
        if(this._fileService.getNewMultipleFilesList().some(x => x === file.name)){
            this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
            return;
        }
        this._fileService.getNewMultipleFilesList().push(file.name);
        this._fileService.getSignedRequest(file, 'nce', 'newplantmap', this._nceService.getRequestID(), this._nceService.getRecordID());
        this.vFileInput.nativeElement.value = "";
    }

    removeMultipleAttachment(pIndex){
        this._fileService.deleteFiles(this._nceService.vNCEData.nce_request_id, 'nce', 'plantmap' , this._fileService.getMultipleFilesList()[pIndex]).then(
            (resolve) => {
                this._fileService.getMultipleFilesList().splice(pIndex, 1);
                this._storageService.setSessionItem('nceMultipleFiles', JSON.stringify(this._fileService.getMultipleFilesList()));
            }, 
            (reject) => {
                this._popupService.openGeneralConfirmationPopup('Error', 'Delete file unsuccessful, please try again', '', false, false);
            }
        );
    }

    removeNewMultipleAttachment(pIndex){
        this._fileService.deleteFiles(this._nceService.vNCEData.nce_request_id, 'nce', 'newplantmap' , this._fileService.getNewMultipleFilesList()[pIndex]).then(
            (resolve) => {
                this._fileService.getNewMultipleFilesList().splice(pIndex, 1);
                this._storageService.setSessionItem('nceNewMultipleFiles', JSON.stringify(this._fileService.getNewMultipleFilesList()));
            }, 
            (reject) => {
                this._popupService.openGeneralConfirmationPopup('Error', 'Delete file unsuccessful, please try again', '', false, false);
            }
        );
    }

    getRequestID(){
        return  this._nceService.vNCEData.nce_request_id || this._nceService.vDetailNCE.nce_request_id || this._nceService.vNCEID.nce_request_id;
    }

    getMultipleFilesList(){
        return this._fileService.getMultipleFilesList();
    }

    getNewMultipleFilesList() {
        return this._fileService.getNewMultipleFilesList();
    }

    overwriteFile(file, type, pIndex){
        if(this._fileService.vFiles[pIndex] !== undefined && this._fileService.vFiles[pIndex] !== '' && this._fileService.vFiles[pIndex] !== null ){
            let prevFileName = this._fileService.vFiles[pIndex];
            this._fileService.vFiles[pIndex] = file.name;
            this._fileService.deleteFiles(this._nceService.vNCEData.nce_request_id, 'nce', type , prevFileName).then(
                (resolve) => {
                    this._fileService.getSignedRequest(file, 'nce', type, this._nceService.getRequestID(), this._nceService.getRecordID());
                },
                (reject) => {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Upload unsuccessful, please try again', '', false, false);
                    this._fileService.vFiles[pIndex] = prevFileName;
                }
            );
        } else {
            this._fileService.vFiles[pIndex] = file.name;
            this._fileService.getSignedRequest(file, 'nce', type, this._nceService.getRequestID(), this._nceService.getRecordID());
        }
    }

    deleteFile(pType: string, pIndex: number){
        this._fileService.deleteFiles(this._nceService.vNCEData.nce_request_id, 'nce', pType , this.getFileList()[pIndex]).then(
            (resolve) => {
                this._fileService.vFiles[pIndex] = '';
                this._storageService.setSessionItem('nceFiles', JSON.stringify(this.getFileList()));
            },
            (reject) => {
                this._popupService.openGeneralConfirmationPopup('Error', 'Delete file unsuccessful, please try again', '', false, false);
            }
        );
    }

    isAbleDeleteFile(pIndex: number){
        return (this.getFileList()[pIndex] !== '' && this.getFileList()[pIndex] !== undefined && this.getFileList()[pIndex] !== null);
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/upload-attachment.component.ts